import { animate, style, transition, trigger, state } from '@angular/animations';

export const expandAnimation = (time: string) =>
  trigger('expandableState', [
    state('open', style({ height: '*', opacity: 1 })),
    state('close', style({ height: '0', opacity: 0 })),
    transition('open <=> close', animate(`${time} ease`))
  ]);
